if (!customElements.get('cart-terms')) {
  class CartTerms extends HTMLElement {
    constructor() {
      super();
      this.cartTermsCheckbox = this.querySelector('.js-cart-terms-checkbox');
      this.form = document.getElementById(this.cartTermsCheckbox.getAttribute('form'));
      this.submitHandler = this.handleSubmit.bind(this);
      this.form.addEventListener('submit', this.submitHandler);
    }

    disconnectedCallback() {
      this.form.removeEventListener('submit', this.submitHandler);
    }

    /**
     * Handles cart form submit
     * @param {object} evt - Event object.
     */
    handleSubmit(evt) {
      if (!this.cartTermsCheckbox.checked) {
        evt.preventDefault();
        alert(theme.strings.cartTermsConfirmation); // eslint-disable-line
      }
    }
  }
  customElements.define('cart-terms', CartTerms);
}

// HC CUSTOM: Enforce the terms checkbox on the click, not on the form submit.
//
// The `submit` listener above never fires. Route ("preferred checkout") and BSS
// B2B both intercept clicks on button[name="checkout"] and then navigate
// programmatically -- BSS via `window.location.href = invoiceUrl` after its
// draft-order call, Route by re-clicking the hidden original button. Because
// BSS calls preventDefault() on the click, the form is never submitted, so the
// guard above is dead code in practice and shoppers reached checkout without
// accepting the terms and refund policy.
//
// A listener on `window` with capture:true is first in the event path, ahead of
// any document-level or element-level app handler, so this holds regardless of
// app load order. Confirmed compatible with Minmaxify, which binds at *document*
// capture and therefore cannot pre-empt this.
//
// Both the cart page and the cart drawer render button[name="checkout"], so one
// gate covers both. Where a cart context has no terms checkbox (the drawer, when
// its `cart_terms_page` setting is blank) this intentionally does nothing.
(function () {
  // Primary gate. Authoritative: every route to checkout, including Route's
  // "Checkout without Coverage" link, ends up re-clicking this button.
  var CHECKOUT_TRIGGER = '[name="checkout"]';

  // Best-effort early gate so the prompt appears immediately when the shopper
  // uses Route's own opt-out link, instead of after Route's ~1s of cart work.
  // Purely a latency improvement -- if Route renames this attribute the primary
  // gate above still holds, so this is safe to let rot.
  var ROUTE_OPT_OUT = '[data-checkout-without-coverage-link]';

  /**
   * Finds the terms checkbox governing a given checkout trigger.
   * Scoped to the trigger's own cart context so a drawer without a checkbox is
   * not blocked by the cart page's, and vice versa.
   * @param {Element} trigger - The clicked checkout control.
   * @returns {Element|null} The checkbox, or null when this context has none.
   */
  function termsCheckboxFor(trigger) {
    var scope = trigger.closest('.cart-drawer__checkout-buttons, #cart-summary, form');
    return scope ? scope.querySelector('.js-cart-terms-checkbox') : null;
  }

  window.addEventListener(
    'click',
    function (evt) {
      var target = evt.target;
      if (!target || !target.closest) return;

      var trigger = target.closest(CHECKOUT_TRIGGER + ',' + ROUTE_OPT_OUT);
      if (!trigger) return;

      var checkbox = termsCheckboxFor(trigger);
      if (!checkbox || checkbox.checked) return;

      // stopImmediatePropagation keeps the click away from Route, BSS and
      // Minmaxify entirely, so no draft order or coverage change is triggered.
      evt.preventDefault();
      evt.stopImmediatePropagation();

      alert(theme.strings.cartTermsConfirmation); // eslint-disable-line

      try {
        checkbox.focus();
      } catch (e) {
        // Focus is a nicety; never let it break the gate.
      }
    },
    true
  );
})();
